import { Ray, Vector2, Vector3 } from "babylonjs";

export class Intersector {
    static intersectSegments(segment1Start: Vector2, segment1End: Vector2, segment2Start: Vector2, segment2End: Vector2): Vector2 | null {
        let x1 = segment1Start.x;
        let y1 = segment1Start.y;
        let x2 = segment1End.x;
        let y2 = segment1End.y;
        let x3 = segment2Start.x;
        let y3 = segment2Start.y;
        let x4 = segment2End.x;
        let y4 = segment2End.y;

        let d = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1);
        if (d == 0.0) {
            return null;
        }

        let yd = y1 - y3;
        let xd = x1 - x3;
        let ua = ((x4 - x3) * yd - (y4 - y3) * xd) / d;
        if (ua < 0 || ua > 1) {
            return null;
        }

        let ub = ((x2 - x1) * yd - (y2 - y1) * xd) / d;
        if (ub < 0 || ub > 1) {
            return null;
        }

        return new Vector2(x1 + (x2 - x1) * ua, y1 + (y2 - y1) * ua);
    }

    static intersectSphereAndRay(center: Vector3, radius: number, ray: Ray): Vector3 | null {
        // cf. https://en.wikipedia.org/wiki/Line–sphere_intersection
        let c = center;
        let r = radius;
        let l = ray.direction;
        let o = ray.origin;

        let discriminant = Math.pow(Vector3.Dot(l, o.subtract(c)), 2) - o.subtract(c).lengthSquared() + r * r;
        if (discriminant < 0) {
            return null;
        }

        let d = -Vector3.Dot(l, o.subtract(c)) - Math.sqrt(discriminant);
        return o.add(l.scale(d));
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/earth/core/intersector.ts